export enum ExtendedNavId {
  Messaging = 'messaging',
  Reports = 'reports',
  Settings = 'settings',
  // The assistant surface uses its OWN open-state (`assistantBarExpanded$` on EmployerNavigationService);
  // never written to `extendedNavContent$`.
  Assistant = 'assistant',
}
